// @flow
// $FlowFixMe
import React, { useMemo } from "react";
import { get, noop } from "lodash";
import Icon from "@fdr/static-ui/Icons";
import buildColor from "@fdr/static-ui/ColorPalette";
import { arrowForward } from "@fdr/static-ui/Icons/icons";
import type { PastRacesResults } from "@fdr/types/ProgramPage";
import type { NullaryFn } from "@tvg/types/Functional";
import RaceResult from "../../_atoms/RaceResult";

import {
  PastPerformanceContainer,
  RaceNumber,
  Number,
  ShowMore,
  MoreTag
} from "./styled-components";

type Props = {
  pastRaces: ?Array<?PastRacesResults>,
  numberOfRaces: number,
  showIPP: boolean,
  openPastPerformances: NullaryFn<void>,
  qaLabel?: string
};

const PastPerformances = (props: Props) => {
  const { pastRaces, numberOfRaces, showIPP, openPastPerformances, qaLabel } =
    props;

  return useMemo(
    () => (
      <PastPerformanceContainer
        data-qa-label={qaLabel || "past-performances-container"}
      >
        <RaceNumber>
          <Number>{numberOfRaces}</Number>
          <span>{numberOfRaces > 1 ? "RACES" : "RACE"}</span>
        </RaceNumber>
        {pastRaces &&
          pastRaces.map((pastRace) => {
            const finishPosition = get(
              pastRace,
              "results.runners[0].finishPosition"
            );

            return (
              <RaceResult
                key={JSON.stringify(pastRace)}
                isEmpty={!pastRace}
                result={finishPosition}
                isPodium={finishPosition && finishPosition <= 3}
                numberOfRunners={+get(pastRace, "numRunners", 0)}
              />
            );
          })}
        {showIPP && (
          <ShowMore
            onClick={openPastPerformances}
            data-qa-label="past-perfomances-show-more"
          >
            <Icon
              icon={arrowForward}
              color={buildColor("blue", "500")}
              size={16}
            />
            <MoreTag>MORE</MoreTag>
          </ShowMore>
        )}
      </PastPerformanceContainer>
    ),
    [JSON.stringify(pastRaces), showIPP]
  );
};

PastPerformances.defaultProps = {
  pastRaces: [],
  numberOfRaces: 0,
  showIPP: true,
  openPastPerformances: noop
};

export default PastPerformances;
